import { server } from "../api";
import axios from "axios";
const UpdateFormula = async (id, a, b, function_type) => {
  let response = await axios.post(server + "formula/update", {
    id,
    a,
    b,
    function: function_type,
  });
  return response.data;
};

const Function7UpdateFormula = async (id, A, B) => {
  let response = await axios.post(server + "formula/update", {
    id,
    a: A[0],
    ra: A[1],
    sa: A[2],
    ta: A[3],
    b: B[0],
    rb: B[1],
    sb: B[2],
    tb: B[3],
    function: 7,
  });
  return response.data;
};
export default { Function7UpdateFormula, UpdateFormula };
